<span matSnackBarLabel>{{ data.message }}</span>

<span matSnackBarActions>
    <button matIconButton matSnackBarAction (click)="snackBarRef.dismissWithAction()">
        <mat-icon>close</mat-icon>
    </button>
</span>
